export default __webpack_public_path__ + "static/media/finance_icon.0bcba422.svg";